import { createContext } from 'react';
import { AuthUser, LoginCredentials, LoginResponse } from '@/application/auth/authTypes';

export interface AuthContextValue {
  user: AuthUser | null;
  token: string | null;
  bootstrapping: boolean;
  login: (credentials: LoginCredentials) => Promise<LoginResponse>;
  impersonate: (username: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
